import { CANCEL_MODAL_EVENT, CLOSE_MODAL_EVENT, CONFIRM_MODAL_EVENT, OPEN_MODAL_EVENT } from "components/preLeaveModalComponent/constants"

export const WIZARD_BUTTON_CANCEL = 'cancel';
export const WIZARD_BUTTON_NEXT = 'next';
export const WIZARD_BUTTON_PREVIOUS = 'previous';
export const WIZARD_BUTTON_FINISH = 'finish';
const CATEGORY_ACTION_EVENT = 'leaveProcess'

export const TEALIUM = {
    sectionFamily: "banking",
    sectionCategory: "products",
    sectionName: "accounts",
    interactionType: "funnel",
    serviceType: "productTransactional",
    processType: "transferAccount",
}

export const STEP_EVENT_NAME= {
    1: "step_select_account",
    2: "step_destination_account",
    3: "step_select_conditions",
    4: "step_confirmation"
}

export const STEP_DESCRIPTION = {
    1: "selectAccount",
    2: "destinationAccount",
    3: "selectConditions",
    4: "confirmation"    
}

export const TEALIUM_EVENTS = {
    [WIZARD_BUTTON_NEXT]: () => ({
        data: true,
        action: 'continue',
        format: 'button',
        component: 'lowerNavigation',
        element: 'next',
        eventCategory: window.utag_data.nombrePagina,
        eventAction: 'lowerNavigation',
        eventLabel: 'next'
    }),
    [WIZARD_BUTTON_PREVIOUS]: () => ({
        data: true,
        action: 'return',
        format: 'button',
        component: 'lowerNavigation',
        element: 'previous',
        eventCategory: window.utag_data.nombrePagina,
        eventAction: 'lowerNavigation',
        eventLabel: 'previous'
    }),
    [WIZARD_BUTTON_CANCEL]: () => ({
        data: true,
        action: 'cancel',
        format: 'link',
        component: 'lowerNavigation',
        element: 'cancel',
        eventCategory: window.utag_data.nombrePagina,
        eventAction: 'clickLink',
        eventLabel: 'cancel'
    }),
    [WIZARD_BUTTON_FINISH]: () => ({
        data: true,
        action: 'click',
        format: 'button',
        component: 'lowerNavigation',
        element: 'createRequest',
        eventCategory: window.utag_data.nombrePagina,
        eventAction: 'lowerNavigation',
        eventLabel: 'createRequest'
    })
}

export const CANCEL_FLOW_MODAL = {
    [OPEN_MODAL_EVENT]: () => ({
        action: "open",
        format: "modal",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "full",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "open",
        eventCategory: window.utag_data.nombrePagina,
    }),
    [CLOSE_MODAL_EVENT]: () => ({
        action: "close",
        format: "cross",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "close",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "close",
        eventCategory: window.utag_data.nombrePagina,
    }),
    [CANCEL_MODAL_EVENT]: () => ({
        action: "cancel",
        format: "link",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "cancel",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "cancel",
        eventCategory: window.utag_data.nombrePagina,
    }),
    [CONFIRM_MODAL_EVENT]: () => ({
        action: "click",
        format: "button",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "leaveProcess",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "leaveProcess",
        eventCategory: window.utag_data.nombrePagina,
    }),
}
